export const useParagraphTokenStore = (
  documentId: string,
  tokenGlobalPosition: number
) => {
  return useParagraphToken(documentId, tokenGlobalPosition)();
};
